import { callApi } from "./api";
import { getQueryString, getOffsetLimitFromPagination } from "../utils/query";

class DoctorsService {

  async getAllDoctors(specializationId) {
    const result = await callApi({
      url: `/api/doctors/?limit=1000&specializations__id=${specializationId}`,
      method: "GET",
    });
    return result;
  } 
   async getDoctors() {
    const result = await callApi({
      url: `/api/doctors/?limit=1000`,
      method: "GET",
    });
    return result;
  }
  async getUnavailableTimes(date,id){
    const result = await callApi({
      url: `/api/medical_report/get_dates/${date}/${id}/`,
      method: "GET",
    });
    return result;
  }
}

export const doctorsService = new DoctorsService();
